/* Copyright 2023 (Unpublished) Verto Inc. */

// Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Modules
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from '@root/app-routing.module';
import { DropdownModule } from 'primeng/dropdown';

// Interceptor
import { IdentityInterceptor } from './root-interceptor/identity-interceptor';

// Components
import { HeaderComponent } from '@root/root-components/header/header.component';
import { AppComponent } from '@root/app.component';
import { LoginComponent } from '@root/root-components/login/login.component';
import { BreadcrumbComponent } from './root-components/breadcrumb/breadcrumb.component';
import { environment } from '../environments/environment';
import { InputSwitchModule } from 'primeng/inputswitch';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { RuntimeEnvModule } from 'ngx-runtime-env';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxObjectDiffModule } from '@root/vendor/ngx-object-diff-master/projects/ngx-object-diff/src/lib/ngx-object-diff.module';
import { PacksComponent } from './packs/packs.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedWebStorage } from './shared-web-storage';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    BreadcrumbComponent,
    PacksComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FontAwesomeModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DropdownModule,
    InputSwitchModule,
    MessagesModule,
    MessageModule,
    OAuthModule.forRoot(),
    RuntimeEnvModule.forRoot(environment, {
      envUrl: 'assets/environment.json',
      optional: true,
    }),
    MatButtonModule,
    MatInputModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatAutocompleteModule,
    NgxObjectDiffModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatSlideToggleModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IdentityInterceptor,
      multi: true,
    },
    MessageService,
    { provide: OAuthStorage, useFactory: () => new SharedWebStorage() },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
